import { create } from "zustand"
import { devtools, persist } from "zustand/middleware"
import { SentenceContinuationItem } from "../fatch/fetchClientSentencesRecent"

interface ContinueWriteState {
  items: SentenceContinuationItem[]
  setData: (v: SentenceContinuationItem[]) => void
  clear: () => void
}

const useContinueWriteStore = create<ContinueWriteState>()(
  devtools(
    persist(
      (set) => ({
        items: [],
        setData: (v) => set({ items: v }),
        clear: () => set({ items: [] }),
      }),
      {
        name: "continue-write-store",
        storage: {
          getItem: (name) => {
            const value = sessionStorage.getItem(name)
            return value ? JSON.parse(value) : null
          },
          setItem: (name, value) => {
            sessionStorage.setItem(name, JSON.stringify(value))
          },
          removeItem: (name) => {
            sessionStorage.removeItem(name)
          },
        },
      },
    ),
  ),
)

export default useContinueWriteStore
